import { render, staticRenderFns } from "./SpecialistGoalsChildScreening.vue?vue&type=template&id=40f20532&scoped=true&"
import script from "./SpecialistGoalsChildScreening.vue?vue&type=script&lang=js&"
export * from "./SpecialistGoalsChildScreening.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistGoalsChildScreening.vue?vue&type=style&index=0&id=40f20532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f20532",
  null
  
)

export default component.exports